import { ResolverTag } from '@ps/web-core-enums';
import { isDefined } from '@ps/web-core-utils';
import { useResolver } from '@ps/web-shared-components';
import type React from 'react';
import { useEffect } from 'react';

import useSearchParams from '@swf/core/hooks/useSearchParams';
import { generatePSNState } from '@swf/core/models/auth/utils';

interface SearchParams {
  code?: string;
  state?: string;
  redirect_uri?: string;
}

const PSNAuthorizationCallback: React.FC = () => {
  const psnAuthAdapterUrl = useResolver(ResolverTag.PsnAuthAdapter);
  const { code, state, redirect_uri: redirectUri } = useSearchParams<SearchParams>();
  const encodedState = isDefined(state) ? state : generatePSNState(code);

  useEffect(() => {
    if (!psnAuthAdapterUrl) {
      return;
    }

    const url = new URL(`${psnAuthAdapterUrl}/api/authorize`);
    url.searchParams.append('state', encodedState ?? '');
    url.searchParams.append('redirect_uri', redirectUri ?? '');
    if (isDefined(code)) {
      url.searchParams.append('code', code);
    }

    window.location.replace(url.toString());
  }, [code, redirectUri, psnAuthAdapterUrl, encodedState]);
  return null;
};

export default PSNAuthorizationCallback;
